import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes } from '../../interfaces/layoutProps';
export const htmlElements = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'span',
    'strong',
    'b',
    'em',
    'i',
    'q',
    'mark',
    'sub',
    'sup',
    'time',
    'figcaption',
];
export const fontWeights = ['normal', 'bold'];
export const textVariants = [
    'copy1',
    'copy2',
    'copy3',
    'order1',
    'order2',
    'order3',
    'order4',
    'display1',
    'display2',
];
export const textPropTypes = {
    variant: PropTypes.oneOf(textVariants),
    as: PropTypes.oneOf(htmlElements),
    weight: PropTypes.oneOf(fontWeights),
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=Text.types.js.map